import { AdministeredDrugValue } from '../../../../generated/api';

export const MedicalOrderOptions: AdministeredDrugValue[] = [
  {
    name: 'Azithromycin',
    dosage: '1g',
    route: 'Oral (PO)',
    notes: 'once for 1 day',
  },
  {
    name: 'Reconstitute with 1% lidocaine',
    dosage: 'as per ceftriaxone monograph',
    route: 'Intramuscular (IM)',
    notes: '',
  },
  {
    name: 'Ceftriaxone',
    dosage: '250mg',
    route: 'Intramuscular (IM)',
    notes: 'once for 1 day',
  },
  {
    name: 'Ceftriaxone',
    dosage: '500mg',
    route: 'Intramuscular (IM)',
    notes: 'once for 1 day',
  },
  {
    name: 'Doxycycline',
    dosage: '100mg',
    route: 'Oral (PO)',
    notes: 'BID for 7 days',
  },
  {
    name: 'Doxycycline',
    dosage: '100mg',
    route: 'Oral (PO)',
    notes: 'BID for 14 days',
  },
  {
    name: 'Doxycycline',
    dosage: '100mg',
    route: 'Oral (PO)',
    notes: 'BID for 21 days',
  },
  {
    name: 'Doxycycline',
    dosage: '100mg',
    route: 'Oral (PO)',
    notes: 'BID for 28 days',
  },
  {
    name: 'Penicillin G',
    dosage: '2.4 million units',
    route: 'Intramuscular (IM)',
    notes: 'once for 1 day',
  },
  {
    name: 'Penicillin G',
    dosage: '2.4 million units',
    route: 'Intramuscular (IM)',
    notes: 'once weekly for 3 weeks',
  },
  {
    name: 'Emla',
    dosage: '1 application',
    route: 'Topical',
    notes: 'once; remove after maximum 5 hours',
  },
];
